import { render, staticRenderFns } from "./page-list.vue?vue&type=template&id=da7b427a&scoped=true"
import script from "./page-list.vue?vue&type=script&lang=ts"
export * from "./page-list.vue?vue&type=script&lang=ts"
import style0 from "./page-list.vue?vue&type=style&index=0&id=da7b427a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7b427a",
  null
  
)

export default component.exports